// extracted by mini-css-extract-plugin
export default {"new-button":"Content__new-button___A93Fj"};